export default {
    Login: {
        ParamInvalid: "Tài khoản, mật khẩu không đúng",
        UserInactive: "Tài khoản bị ngừng kích hoạt",
    },
};  
